












import { Component, Vue } from 'vue-property-decorator'
import CardSlider from '@/components/home/CardSlider.vue'
import HeaderCarousel from '@/components/home/HeaderCarousel.vue'
import ActivationBanner from '@/components/home/ActivationBanner.vue'
import homeModule from '@/store/home'
import eventModule from '@/store/event'
import authModule from '@/store/auth'
import { CardList } from '@/types/Card'

@Component({
  components: {
    CardSlider,
    HeaderCarousel,
    ActivationBanner
  }
})
export default class HomeView extends Vue {
  private async created() {
    eventModule.setLoading(true)
    await homeModule.fetchAll()
    eventModule.setLoading(false)
  }

  private get loading() {
    return eventModule.loading
  }

  private get confirmed(): boolean {
    return authModule.user?.confirmed || false
  }

  private get loggedIn(): boolean {
    return authModule.user ? true : false
  }

  private get storeModule() {
    return homeModule
  }

  private get cardlists(): CardList[] {
    return homeModule.cardlists
  }
}
